<template>
    <!-- 主題活動 > 參與店家 -->
    <div class="Store">
        <div class="container">
            <div class="list-style" v-for="(item, index) in dataList" :key="index"
                 @click="$router.push({name: 'StoreInfo', query:{id:item.id}})">
                <div class="mr-3">
                    <el-image :src="item.imgUrl" fit="cover" class="pic2"></el-image>
                    <p class="distance" v-if="item.distance !== ''"><img src="@/assets/images/location_blue_line.svg">{{item.distance}}</p>
                </div>
                <div class="content">
                    <h2>{{item.name}}</h2>
                    <div class="phone-btn">
                        <a @click.stop="$public.callTel(item.tel)" v-if="item.tel !== ''">
                            <img src="@/assets/images/phone.svg">
                            <span>{{item.tel}}</span>
                        </a>
                    </div>
                    <div class="location-btn">
                        <a @click.stop="onClickLocationBtn(item.lat, item.lng, item.googleMapUrl)" v-if="item.city !== ''">
                            <img src="@/assets/images/location_blue.svg">
                            <span>{{item.city}}{{item.township}}{{item.address}}</span>
                        </a>
                    </div>
                    <!--todo 外送資訊-->
                    <div class="takeout-list single mt-2" @click="isOpen(index)" v-if="false">
                        <div class="title">
                            <i class="el-icon-goods"/>外送：
                        </div>
                        <div class="con">
                            0-3km 滿$500 免運<br>
                            3km以上-4km $50<br>
                            5km以上-7km $100<br>
                        </div>
                        <div class="icon-arrow">
                            <i class="el-icon-caret-bottom"/>
                        </div>
                    </div>
                </div>

                <!--            <p class="coin">-->
                <!--                <img src="@/assets/images/coin.svg">-->
                <!--                享樂幣最高可抵用100%-->
                <!--                <img src="@/assets/images/tag.svg" class="tag">-->
                <!--                95折-->
                <!--            </p>-->
            </div>
        </div>

        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
    </div>
</template>

<script>

    export default {
        name: 'ActivityStore',
        data() {
            return {
                id: this.$route.query.id,
                dataList: [],
                lng: 0,
                lat: 0,
                isLoading: true,
            }
        },
        created() {
            let self = this;
            let onSuccess = function(position) {
                self.lng = position.coords.longitude;
                self.lat = position.coords.latitude;

                self.setupData();
            };
            let onError = function(error) {
                self.lng = 0;
                self.lat = 0;
                self.setupData();
                self.$public.showNotify("code: "+error.code+", message: "+error.message+"。無法定位GPS", false, 3000)
            };

            self.$public.getGpsLocation(onSuccess, onError);
        },
        methods: {
            setupData() {
                this.$http.fetch`GetOinActivityJoinStoreList${{
                    'id': parseInt(this.id),
                    'lng':  this.lng,
                    'lat':  this.lat,
                }} ${json => {
                    this.dataList = json;
                    this.isLoading = false;
                }}`;
            },

            /** 外送詳細開合 */
            isOpen: function() {
                document.getElementsByClassName('takeout-list')[0].classList.toggle("open")
            },

            /** 點擊地點按鈕 */
            onClickLocationBtn: function (lat = 0, lng = 0, googleMapUrl = null) {

                if (this.$public.notNull(googleMapUrl) && googleMapUrl !== '') {
                    let param = this.$public.analyzeGoogleMapUrl(googleMapUrl);

                    if (this.$public.notNull(param)) {
                        //開啓地圖
                        if (this.$public.notNull(param.googleMapStoreInfoData) && param.googleMapLat > 0 && param.googleMapLng > 0) {
                            //爲避免店家輸入的url打開後效果不統一，一律先分析再從公用函式開啓頁面
                            this.$public.openMap(param.googleMapLat, param.googleMapLng, param.googleMapStoreInfoData);
                        } else {
                            this.$public.openMap(param.googleMapLat, param.googleMapLng);
                        }
                    }

                } else if (lat !== 0 && lng !== 0) {
                    this.$public.openMap(lat, lng);
                }
            },
        }
    }
</script>
<style lang="less" scoped src="../../less/activity.less"/>